export default {
  areaCode_China: '中國',
  areaCode_Macau: '中國澳門',
  areaCode_Taiwan: '中國臺灣',
  areaCode_HongKong: '中國香港',
  areaCode_Albania: '阿爾巴尼亞',
  areaCode_Algeria: '阿爾及利亞',
  areaCode_Afghanistan: '阿富汗',
  areaCode_Argentina: '阿根廷',
  areaCode_UnitedArabEmirates: '阿拉伯聯合酋長國',
  areaCode_Aruba: '阿魯巴',
  areaCode_Oman: '阿曼',
  areaCode_Azerbaijan: '阿塞拜疆',
  areaCode_Egypt: '埃及',
  areaCode_Ethiopia: '埃塞俄比亞',
  areaCode_Ireland: '愛爾蘭',
  areaCode_Estonia: '愛沙尼亞',
  areaCode_Andorra: '安道爾',
  areaCode_Angola: '安哥拉',
  areaCode_Anguilla: '安圭拉',
  areaCode_AntiguaAndBarbuda: '安提瓜和巴布達',
  areaCode_Austria: '奧地利',
  areaCode_Australia: '澳大利亞',
  areaCode_Barbados: '巴巴多斯',
  areaCode_PapuaNewGuinea: '巴布亞新幾內亞',
  areaCode_Bahamas: '巴哈馬',
  areaCode_Pakistan: '巴基斯坦',
  areaCode_Paraguay: '巴拉圭',
  areaCode_Palestine: '巴勒斯坦',
  areaCode_Bahrain: '巴林',
  areaCode_Panama: '巴拿馬',
  areaCode_Brazil: '巴西',
  areaCode_Belarus: '白俄羅斯',
  areaCode_Bermuda: '百慕大群島',
  areaCode_Bulgaria: '保加利亞',
  areaCode_Benin: '貝寧',
  areaCode_Belgium: '比利時',
  areaCode_Iceland: '冰島',
  areaCode_PuertoRico: '波多黎各',
  areaCode_Poland: '波蘭',
  areaCode_BosniaandHerzegovina: '波斯尼亞和黑塞哥維',
  areaCode_Bolivia: '玻利維亞',
  areaCode_Belize: '伯利茲',
  areaCode_Botswana: '博茨瓦納',
  areaCode_Bhutan: '不丹',
  areaCode_BurkinaFaso: '布基納法索',
  areaCode_Burundi: '布隆迪',
  areaCode_EquatorialGuinea: '赤道幾內亞',
  areaCode_Denmark: '丹麥',
  areaCode_Germany: '德國',
  areaCode_TimorLeste: '東帝汶',
  areaCode_Togo: '多哥',
  areaCode_Dominica: '多米尼加',
  areaCode_DominicanRepublic: '多米尼加共和國',
  areaCode_Russia: '俄羅斯',
  areaCode_Ecuador: '厄瓜多爾',
  areaCode_Eritrea: '厄立特裏亞',
  areaCode_France: '法國',
  areaCode_FaroeIslands: '法羅群島',
  areaCode_FrenchPolynesia: '法屬波利尼西亞',
  areaCode_FrenchGuiana: '法屬圭亞那',
  areaCode_Philippines: '菲律賓',
  areaCode_Fiji: '斐濟',
  areaCode_Finland: '芬蘭',
  areaCode_Gambia: '岡比亞',
  areaCode_RepublicOfTheCongo: '剛果共和國',
  areaCode_DemocraticRepublicof: '剛果民主共和國',
  areaCode_Colombia: '哥倫比亞',
  areaCode_CostaRica: '哥斯達黎加',
  areaCode_Grenada: '格林納達',
  areaCode_Greenland: '格陵蘭島',
  areaCode_Georgia: '格魯吉亞',
  areaCode_Cuba: '古巴',
  areaCode_Guadeloupe: '瓜德羅普島',
  areaCode_Guatemala: '瓜地馬拉',
  areaCode_Guam: '關島',
  areaCode_Guyana: '圭亞那',
  areaCode_Kazakhstan: '哈薩克斯坦',
  areaCode_Haiti: '海地',
  areaCode_SouthKorea: '韓國',
  areaCode_Netherlands: '荷蘭',
  areaCode_Montenegro: '黑山',
  areaCode_Honduras: '洪都拉斯',
  areaCode_Djibouti: '吉布提',
  areaCode_Kiribati: '基裏巴斯',
  areaCode_Kyrgyzstan: '吉爾吉斯斯坦',
  areaCode_Guinea: '幾內亞',
  areaCode_GuineaBissau: '幾內亞比紹共和國',
  areaCode_Canada: '加拿大',
  areaCode_Ghana: '加納',
  areaCode_Gabon: '加蓬',
  areaCode_Cambodia: '柬埔寨',
  areaCode_Czech: '捷克',
  areaCode_Zimbabwe: '津巴布韋',
  areaCode_Cameroon: '喀麥隆',
  areaCode_Qatar: '卡塔爾',
  areaCode_CaymanIslands: '開曼群島',
  areaCode_CapeVerde: '開普',
  areaCode_Comoros: '科摩羅',
  areaCode_Kuwait: '科威特',
  areaCode_Croatia: '克羅地亞',
  areaCode_Kenya: '肯尼亞',
  areaCode_CookIslands: '庫克群島',
  areaCode_Curacao: '庫拉索',
  areaCode_Latvia: '拉脫維亞',
  areaCode_Lesotho: '萊索托',
  areaCode_Laos: '老撾',
  areaCode_Lebanon: '黎巴嫩',
  areaCode_Lithuania: '立陶宛',
  areaCode_Liberia: '利比裏亞',
  areaCode_Libya: '利比亞',
  areaCode_Liechtenstein: '列支敦士登',
  RéunionIsland: '留尼汪',
  areaCode_Luxembourg: '盧森堡',
  areaCode_Rwanda: '盧旺達',
  areaCode_Romania: '羅馬尼亞',
  areaCode_Madagascar: '馬達加斯加',
  areaCode_Maldives: '馬爾代夫',
  areaCode_Malta: '馬耳他',
  areaCode_Malawi: '馬拉維',
  areaCode_Malaysia: '馬來西亞',
  areaCode_Mali: '馬裏',
  areaCode_Macedonia: '馬其頓',
  areaCode_Martinique: '馬提尼克',
  areaCode_Mayotte: '馬約特',
  areaCode_Mauritius: '毛裏求斯',
  areaCode_Mauritania: '毛裏塔尼亞',
  areaCode_UnitedStates: '美國',
  areaCode_AmericanSamoa: '美屬薩摩亞',
  areaCode_VirginIslandsUS: '美屬維爾京群島',
  areaCode_Mongolia: '蒙古',
  areaCode_Montserrat: '蒙特塞拉特島',
  areaCode_Bangladesh: '孟加拉國',
  areaCode_Peru: '秘魯',
  areaCode_Myanmar: '緬甸',
  areaCode_Moldova: '摩爾多瓦',
  areaCode_Morocco: '摩洛哥',
  areaCode_Monaco: '摩納哥',
  areaCode_Mozambique: '莫桑比克',
  areaCode_Mexico: '墨西哥',
  areaCode_Namibia: '納米比亞',
  areaCode_SouthAfrica: '南非',
  areaCode_Nepal: '尼泊爾',
  areaCode_Nicaragua: '尼加拉瓜',
  areaCode_Niger: '尼日爾',
  areaCode_Nigeria: '尼日利亞',
  areaCode_Norway: '挪威',
  areaCode_Palau: '帕勞',
  areaCode_Portugal: '葡萄牙',
  areaCode_Japan: '日本',
  areaCode_Sweden: '瑞典',
  areaCode_Switzerland: '瑞士',
  areaCode_ElSalvador: '薩爾瓦多',
  areaCode_Samoa: '薩摩亞',
  areaCode_Serbia: '塞爾維亞',
  areaCode_SierraLeone: '塞拉利昂',
  areaCode_Senegal: '塞內加爾',
  areaCode_Cyprus: '塞浦路斯',
  areaCode_Seychelles: '塞舌爾',
  areaCode_SaudiArabia: '沙特阿拉伯',
  areaCode_SaintPierreandMiquel: '聖彼埃爾和密克隆島',
  areaCode_SaoTomeandPrincipe: '聖多美和普林西比',
  areaCode_SaintKittsandNevis: '聖基茨和尼維斯',
  areaCode_SaintLucia: '聖露西亞',
  areaCode_SintMaartenDutchPar: '聖馬丁島（荷蘭部分',
  areaCode_SanMarino: '聖馬力諾',
  areaCode_SaintVincentandTheG: '聖文森特和格林納丁',
  areaCode_SriLanka: '斯裏蘭卡',
  areaCode_Slovakia: '斯洛伐克',
  areaCode_Slovenia: '斯洛文尼亞',
  areaCode_Swaziland: '斯威士蘭',
  areaCode_Sudan: '蘇丹',
  areaCode_Suriname: '蘇裏南',
  areaCode_SolomonIslands: '所羅門群島',
  areaCode_Somalia: '索馬裏',
  areaCode_Tajikistan: '塔吉克斯坦',
  areaCode_Thailand: '泰國',
  areaCode_Tanzania: '坦桑尼亞',
  areaCode_Tonga: '湯加',
  areaCode_TurksandCaicosIsland: '特克斯和凱科斯群島',
  areaCode_TrinidadandTobago: '特立尼達和多巴哥',
  areaCode_Tunisia: '突尼斯',
  areaCode_Turkey: '土耳其',
  areaCode_Turkmenistan: '土庫曼斯坦',
  areaCode_Vanuatu: '瓦努阿圖',
  areaCode_Venezuela: '委內瑞拉',
  areaCode_Brunei: '文萊',
  areaCode_Uganda: '烏幹達',
  areaCode_Ukraine: '烏克蘭',
  areaCode_Uruguay: '烏拉圭',
  areaCode_Uzbekistan: '烏茲別克斯坦',
  areaCode_Spain: '西班牙',
  areaCode_Greece: '希臘',
  areaCode_IvoryCoast: '象牙海岸',
  areaCode_Singapore: '新加坡',
  areaCode_NewCaledonia: '新喀裏多尼亞',
  areaCode_NewZealand: '新西蘭',
  areaCode_Hungary: '匈牙利',
  areaCode_Syria: '敘利亞',
  areaCode_Jamaica: '牙買加',
  areaCode_Armenia: '亞美尼亞',
  areaCode_Yemen: '也門',
  areaCode_Iraq: '伊拉克',
  areaCode_Iran: '伊朗',
  areaCode_Israel: '以色列',
  areaCode_Italy: '意大利',
  areaCode_India: '印度',
  areaCode_Indonesia: '印度尼西亞',
  areaCode_UnitedKingdom: '英國',
  areaCode_VirginIslandsBritish: '英屬處女群島',
  areaCode_Jordan: '約旦',
  areaCode_Vietnam: '越南',
  areaCode_Zambia: '贊比亞',
  areaCode_Chad: '乍得',
  areaCode_Gibraltar: '直布羅陀',
  areaCode_Chile: '智利',
  areaCode_CentralAfricanRepubli: '中非共和國',
}
